import {GetterTree} from "vuex";
import {PriorityRulesState} from "@/store/rules/priority_rules/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<PriorityRulesState, RootState> = {
  priorityRules:state => state.priorityRules,
  priorityRuleItem:state => state.priorityRuleItem
}